import React from 'react'
import Link from "next/link"
import { Button } from "@/components/ui/button"
import { getCustomer } from '@lib/data/customer'


export async function AuthButtons() {
    const customer = await getCustomer()
    return (
        <div className="flex justify-center w-full mb-6">
            {!customer ? (
                <>
                    <Link
                        className="w-full"
                        href={"/account/sign-in"}
                    >
                        <Button className="w-full rounded-r-none border-y-2 border-l-2 border-muted-accent bg-bg-component hover:bg-bg-component hover:text-button-primary-lighten text-ui-fg-subtle px-5">
                            GİRİŞ YAP
                        </Button>
                    </Link>
                    <Link
                        className="w-full"
                        href={"/account/sign-up"}
                    >
                        <Button className="w-full rounded-l-none border-y-2 border-r-2 border-muted-accent bg-button-primary hover:bg-button-primary-lighten text-slate-900 px-5">
                            KAYIT OL
                        </Button>
                    </Link>
                </>
            ) : (
                <Link
                    className="w-full"
                    href={"/account/sign-in"}
                >
                    <Button className="w-full rounded-r-none border-y-2 border-l-2 border-muted-accent bg-bg-component hover:bg-bg-component hover:text-button-primary-lighten text-ui-fg-subtle px-5">
                        GİRİŞ YAP
                    </Button>
                </Link>
            )}
        </div>
    )
}

